// extracted by mini-css-extract-plugin
export default {"not_found_container":"style_not_found_container__0GMNX"};